import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { Backdrop, Modal, Paper } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import clsx from 'clsx'
import Fade from '../Fade'
import { usePopupModal } from './PopupModal.hooks'

const PopupModal = props => {
	const [{ className, classes, open, children, closable, paperRef, paperStyle }, { handleClose }] = usePopupModal(
		props,
	)

	return (
		<Modal
			className={clsx(classes.modal, className, 'popup-modal')}
			open={open}
			onClose={handleClose}
			closeAfterTransition
			disableEnforceFocus
			disableAutoFocus
			BackdropComponent={Backdrop}
			BackdropProps={{
				timeout: { enter: 300, exit: 200 },
				onClick: handleClose,
				className: classes.backDrop,
			}}
		>
			<Fade ref={paperRef} in={open} className={classes.fade}>
				<Paper className={clsx(classes.paper, 'popup-modal-content')} elevation={3} style={paperStyle}>
					{children}
					{closable && <CloseIcon className={classes.close} onClick={handleClose} />}
				</Paper>
			</Fade>
		</Modal>
	)
}

PopupModal.propTypes = {
	blurred: PropTypes.bool,
	open: PropTypes.bool,
	onClose: PropTypes.func,
	children: PropTypes.node,
	className: PropTypes.string,
	closable: PropTypes.bool,
}

export default memo(PopupModal)
